import { css } from '@emotion/css';

export const editorStyles = css`
  .lygo-editor *::selection {
    color: var(--text-highlight);
    background: var(--bg-highlight);
  }

  .lygo-editor {
    ul,
    ol {
      padding-inline-start: 1.5em;
    }
    ol {
      list-style-type: decimal;
    }
    ul {
      list-style-type: disc;
    }
    ul li,
    ol li {
      padding-inline-start: 0.5em;
    }
    li::marker {
      font-size: unset;
    }
  }
`;
